import { extendTheme } from '@chakra-ui/react';

import { colors } from '../packages/common-frontend/colors';

const tableStyles = {
  bg: 'millet.50',
  color: '#0E0E0E',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '20px',
  textTransform: 'capitalize',
  letterSpacing: 0,
};

const components = {
  Button: {
    baseStyle: {
      fontWeight: 'bold',
    },
    variants: {
      link: {
        color: 'default',
        textDecoration: 'underline',
      },
    },
  },
  // 3rd party custom component used in <FilterDatePicker>
  ChakraReactDatePicker: {
    baseStyle: {
      bg: 'white',
    },
  },
  Table: {
    baseStyle: {
      thead: tableStyles,
      th: tableStyles,
    },
  },
  /**
   * Chakra-UI Default tabs colorScheme is blue. Any "invalid" colorScheme forces the tab to render black. Don't know why Chakra-UI doesn't have a black by default. blackAlpha renders a gray selected tab
   * Setting the colors in the base style as black won't override the default color scheme of blue
   * */
  Tabs: {
    baseStyle: {
      tab: {
        pl: '0',
        pr: '0',
        minW: '100px',
        mr: 10,
        mt: 10,
        _selected: {
          fontWeight: 'bold',
          borderBottom: '2px',
        },
      },
    },
  },
};

const theme = extendTheme({
  colors,
  components,
  styles: {
    global: {
      // See https://github.com/chakra-ui/chakra-ui/issues/7629
      '.chakra-input__group': {
        isolation: 'auto !important',
      },
    },
  },
});

export default theme;
